<template>
  <input
    class="reset input"
    type="password"
    v-model="password"
  >
</template>

<script>
export default {
  computed: {
    password: {
      get () {
        return this.$store.state.signup.password
      } ,

      set (password) {
        this.$store.commit('signup/setPassword', password)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_input.scss';
</style>
